import { reactive, onBeforeUnmount, onMounted } from '@vue/composition-api'
//
import handleValueOrFunction from '@iez/lib/handle-value-or-function/'
import { routeCurrent } from '@iez/core/router/'

/**
 * title,
 * onBack
 */
export const state = reactive({
  topBar: null
})

export default () => {
  const methods = {
    set: topBar => {
      onMounted(() => {
        handleValueOrFunction({
          valueOrFunction: topBar,
          callback: topBar => {
            if (topBar) {
              state.topBar = topBar
            } else {
              state.topBar = null
            }
          }
        })
      })
      onBeforeUnmount(() => {
        if (
          routeCurrent.name !== `Search` &&
          routeCurrent.popState !== `Search`
        )
        state.topBar = null
      })
      return state.topBar
    }
  }

  return {
    state,
    ...methods
  }
}
